<!-- TODO this all via formly -->

<p-tabs #tabs value="0">
    <p-tablist>
        <p-tab value="0">{{ 'common.general' | translate }}</p-tab>
        <!-- disabled for now -->
        <p-tab disabled value="1">{{ 'product.cross-sells' | translate }}</p-tab>
    </p-tablist>

    <p-tabpanels>
        <p-tabpanel value="0">
            <app-taxonomy-category-drop-down></app-taxonomy-category-drop-down>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>
